import React, {
  useReducer,
  useContext,
  useCallback,
  useState,
  useEffect,
} from "react";
import axios from "axios";

export const AuthContext = React.createContext();
const BASE_URL = "https://catway.services.ombre.app/v1/";

export const Authentication = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [reg, setReg] = useState({});
  const [user, setUser] = useState({});
  const [ratingStat, setRatingstat] = useState(false);
  const [score, setScore] = useState({});
  const [userSetting, setUserSetting] = useState({});

  useEffect(() => {
    getStatus();
  }, []);

  const getStatus = () => {
    const loggedIn = window.localStorage.getItem("accessToken");
    if (loggedIn) {
      setIsAuthenticated(true);
    } else {
      return null;
    }
  };

  const Login = (email, password) => {
    return axios
      .post(BASE_URL + "auth/login", {
        email,
        password,
      })
      .then((response) => {
        setIsAuthenticated(true);
        setUser(response.data);
        window.localStorage.setItem(
          "accessToken",
          response.data.data.token.access_token
        );
      });
  };

  const SocialLogin = useCallback((data) => {
    return axios
      .post(
        BASE_URL + "auth/social-media/login",
        {
          email: data.name,
          origin: "web",
          deviceType: "",
          deviceToken: "",
          provider: data.provider,
          accessToken: data.accessToken,
          id: data.id,
          fullName: data.name,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsAuthenticated(true);
        setUser(data);
        window.localStorage.setItem(
          "accessToken",
          response.data.data.token.access_token
        );
      });
  });

  const Register = useCallback((email, password, fullName, displayName) => {
    return axios
      .post(BASE_URL + "auth/register", {
        origin: "web",
        role: "user",
        email,
        password,
        fullName,
        displayName,
      })
      .then((res) => {
        setReg(res);
        return res;
      });
  });

  const updateUser = useCallback((fullName, displayName) => {
    return axios
      .put(
        BASE_URL + "users/" + `${user && user.data ? user.data.id : user.id}`,
        {
          fullName: fullName,
          displayName: displayName,
        },
        {
          headers: {
            Authorization: "Bearer " + user.data.token.access_token,
          },
        }
      )
      .then((response) => {
        setUser(response.data);
      });
  });

  const updateEmail = (email, password) => {
    return axios
      .put(
        BASE_URL + "users/" + `${user && user.data ? user.data.id : user.id}`,
        {
          email: email,
          password: password,
        },
        {
          headers: {
            Authorization: "Bearer " + user.data.token.access_token,
          },
        }
      )
      .then((response) => {
        setUser(response.data);
      });
  };

  const getSetting = () => {
    return axios
      .get(BASE_URL + "users/" + user.data.id + "/profile/settings", {
        headers: { Authorization: "Bearer " + user.data.token.access_token },
      })
      .then((response) => {
        setUserSetting(response.data);
      });
  };

  const StartRating = useCallback(() => {
    setRatingstat(true);
  });

  const dispatchScore = useCallback((data) => {
    setScore(data);
  });

  const SignatureKey = useCallback(
    (gender, height, skinTone, bodyShape, age, weight, dob) => {
      const key = reg.data.data.id;
      return axios.post(
        BASE_URL + "generate-signature/" + key,
        {
          gender,
          height,
          skinTone,
          bodyShape,
          age,
          unit: "metric",
          weight,
          dob,
          profileId: key,
        },
        {
          headers: {
            Authorization: "Bearer " + reg.data.data.token.access_token,
          },
        }
      );
    }
  );

  const AddTrait = useCallback(
    (gender, height, skinTone, bodyShape, age, weight, dob) => {
      const id = reg.data.data.id;
      return axios.post(
        BASE_URL + "users/" + id + "/profiles",
        {
          gender,
          height,
          skinTone,
          bodyShape,
          age,
          unit: "metric",
          weight,
          dob,
        },
        {
          headers: {
            Authorization: "Bearer " + reg.data.data.token.access_token,
          },
        }
      );
    }
  );

  const Logout = () => {
    window.localStorage.clear();
    setIsAuthenticated(false);
  };

  const ResetPassword = (email) => {
    return axios.post(BASE_URL + "auth/password-recovery", {
      email,
    });
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        Login,
        SocialLogin,
        user,
        StartRating,
        dispatchScore,
        score,
        getSetting,
        userSetting,
        updateUser,
        updateEmail,
        Logout,
        Register,
        SignatureKey,
        AddTrait,
        ResetPassword,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default Authentication;
export const useAuth = () => useContext(AuthContext);
